// Utils
import { connect } from 'react-redux';

// Components
import AuthModal from '../components/auth-modal/auth-modal';

// Actions
import { signIn } from '../lib/actions';
import { sendHACRegistrationEmail } from '../lib/actions/send-transactional-email';

const mapDispatchToProps = (dispatch) => ({
  onSignIn(identity) {
    dispatch(signIn(identity));
  },
  onRegistration() {
    dispatch(sendHACRegistrationEmail());
  },
});

export default connect(null, mapDispatchToProps)(AuthModal);
